import { createSlice } from '@reduxjs/toolkit'
import { AxiosError } from '@src/helpers/httpClient'

import {
  GLOBAL_STATE,
  ICONFERENCE,
  ICONFERENCE_ALL,
  ICONFERENCE_ALL_FILTER,
  ICONFERENCE_ARTICLE,
  ICONFERENCE_ARTICLE_ALL,
  ICONFERENCE_ARTICLE_LIST,
  ICONFERENCE_ARTICLE_PROOF,
  ICONFERENCE_ARTICLE_STEP,
  ICONFERENCE_CATEGORY_ALL,
  ICONFERENCE_CREATE,
  ICONFERENCE_MAGAZINE_ARTICLE,
} from '../constants/actionTypes'
import * as actionCreators from './actions'
import { defaultState, initialState } from './initialState'

export const ICONFERENCES = GLOBAL_STATE

export const { reducer: iconferenceReducer } = createSlice({
  name: ICONFERENCES,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(actionCreators.iconference.pending, state => {
        state[ICONFERENCE].loading = true
      })
      .addCase(actionCreators.iconference.rejected, (state, action) => {
        state[ICONFERENCE].loading = false
        state[ICONFERENCE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.iconference.fulfilled, (state, action) => {
        state[ICONFERENCE].loading = false
        state[ICONFERENCE].error = null
        state[ICONFERENCE].data = action.payload
      })

    builder
      .addCase(actionCreators.iconferenceCreate.pending, state => {
        state[ICONFERENCE_CREATE].loading = true
      })
      .addCase(actionCreators.iconferenceCreate.rejected, (state, action) => {
        state[ICONFERENCE_CREATE].loading = false
        state[ICONFERENCE_CREATE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.iconferenceCreate.fulfilled, (state, action) => {
        state[ICONFERENCE_CREATE].loading = false
        state[ICONFERENCE_CREATE].error = null
        state[ICONFERENCE_CREATE].data = action.payload
      })

    builder
      .addCase(actionCreators.iconferenceAll.pending, state => {
        state[ICONFERENCE_ALL].loading = true
      })
      .addCase(actionCreators.iconferenceAll.rejected, (state, action) => {
        state[ICONFERENCE_ALL].loading = false
        state[ICONFERENCE_ALL].error = action.payload as AxiosError
      })
      .addCase(actionCreators.iconferenceAll.fulfilled, (state, action) => {
        state[ICONFERENCE_ALL].loading = false
        state[ICONFERENCE_ALL].error = null
        state[ICONFERENCE_ALL].data = action.payload
      })

    builder
      .addCase(actionCreators.iconferenceAllFilter.pending, state => {
        state[ICONFERENCE_ALL_FILTER].loading = true
      })
      .addCase(actionCreators.iconferenceAllFilter.rejected, (state, action) => {
        state[ICONFERENCE_ALL_FILTER].loading = false
        state[ICONFERENCE_ALL_FILTER].error = action.payload as AxiosError
      })
      .addCase(actionCreators.iconferenceAllFilter.fulfilled, (state, action) => {
        state[ICONFERENCE_ALL_FILTER].loading = false
        state[ICONFERENCE_ALL_FILTER].error = null
        state[ICONFERENCE_ALL_FILTER].data = action.payload
      })

    builder
      .addCase(actionCreators.iconferenceArticle.pending, state => {
        state[ICONFERENCE_ARTICLE].loading = true
      })
      .addCase(actionCreators.iconferenceArticle.rejected, (state, action) => {
        state[ICONFERENCE_ARTICLE].loading = false
        state[ICONFERENCE_ARTICLE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.iconferenceArticle.fulfilled, (state, action) => {
        state[ICONFERENCE_ARTICLE].loading = false
        state[ICONFERENCE_ARTICLE].error = null
        state[ICONFERENCE_ARTICLE].data = action.payload
      })

    builder
      .addCase(actionCreators.iconferenceArticleList.pending, state => {
        state[ICONFERENCE_ARTICLE_LIST].loading = true
      })
      .addCase(actionCreators.iconferenceArticleList.rejected, (state, action) => {
        state[ICONFERENCE_ARTICLE_LIST].loading = false
        state[ICONFERENCE_ARTICLE_LIST].error = action.payload as AxiosError
      })
      .addCase(actionCreators.iconferenceArticleList.fulfilled, (state, action) => {
        state[ICONFERENCE_ARTICLE_LIST].loading = false
        state[ICONFERENCE_ARTICLE_LIST].error = null
        state[ICONFERENCE_ARTICLE_LIST].data = action.payload
      })

    builder
      .addCase(actionCreators.iconferenceArticleAll.pending, state => {
        state[ICONFERENCE_ARTICLE_ALL].loading = true
      })
      .addCase(actionCreators.iconferenceArticleAll.rejected, (state, action) => {
        state[ICONFERENCE_ARTICLE_ALL].loading = false
        state[ICONFERENCE_ARTICLE_ALL].error = action.payload as AxiosError
      })
      .addCase(actionCreators.iconferenceArticleAll.fulfilled, (state, action) => {
        state[ICONFERENCE_ARTICLE_ALL].loading = false
        state[ICONFERENCE_ARTICLE_ALL].error = null
        state[ICONFERENCE_ARTICLE_ALL].data = action.payload
      })

    builder
      .addCase(actionCreators.iconferenceMagazineArticle.pending, state => {
        state[ICONFERENCE_MAGAZINE_ARTICLE].loading = true
      })
      .addCase(actionCreators.iconferenceMagazineArticle.rejected, (state, action) => {
        state[ICONFERENCE_MAGAZINE_ARTICLE].loading = false
        state[ICONFERENCE_MAGAZINE_ARTICLE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.iconferenceMagazineArticle.fulfilled, (state, action) => {
        state[ICONFERENCE_MAGAZINE_ARTICLE].loading = false
        state[ICONFERENCE_MAGAZINE_ARTICLE].error = null
        state[ICONFERENCE_MAGAZINE_ARTICLE].data = action.payload
      })

    builder
      .addCase(actionCreators.iconferenceArticleStep.pending, state => {
        state[ICONFERENCE_ARTICLE_STEP].loading = true
      })
      .addCase(actionCreators.iconferenceArticleStep.rejected, (state, action) => {
        state[ICONFERENCE_ARTICLE_STEP].loading = false
        state[ICONFERENCE_ARTICLE_STEP].error = action.payload as AxiosError
      })
      .addCase(actionCreators.iconferenceArticleStep.fulfilled, (state, action) => {
        state[ICONFERENCE_ARTICLE_STEP].loading = false
        state[ICONFERENCE_ARTICLE_STEP].error = null
        state[ICONFERENCE_ARTICLE_STEP].data = action.payload
      })

    builder
      .addCase(actionCreators.iconferenceArticleProof.pending, state => {
        state[ICONFERENCE_ARTICLE_PROOF].loading = true
      })
      .addCase(actionCreators.iconferenceArticleProof.rejected, (state, action) => {
        state[ICONFERENCE_ARTICLE_PROOF].loading = false
        state[ICONFERENCE_ARTICLE_PROOF].error = action.payload as AxiosError
      })
      .addCase(actionCreators.iconferenceArticleProof.fulfilled, (state, action) => {
        state[ICONFERENCE_ARTICLE_PROOF].loading = false
        state[ICONFERENCE_ARTICLE_PROOF].error = null
        state[ICONFERENCE_ARTICLE_PROOF].data = action.payload
      })

    builder
      .addCase(actionCreators.iconferenceCategoryAll.pending, state => {
        state[ICONFERENCE_CATEGORY_ALL].loading = true
      })
      .addCase(actionCreators.iconferenceCategoryAll.rejected, (state, action) => {
        state[ICONFERENCE_CATEGORY_ALL].loading = false
        state[ICONFERENCE_CATEGORY_ALL].error = action.payload as AxiosError
      })
      .addCase(actionCreators.iconferenceCategoryAll.fulfilled, (state, action) => {
        state[ICONFERENCE_CATEGORY_ALL].loading = false
        state[ICONFERENCE_CATEGORY_ALL].error = null
        state[ICONFERENCE_CATEGORY_ALL].data = action.payload
      })

    builder.addCase(actionCreators.iconferenceClear, state => {
      state[ICONFERENCE] = defaultState()
    })

    builder.addCase(actionCreators.iconferenceArticleClear, state => {
      state[ICONFERENCE_ARTICLE] = defaultState()
    })

    builder.addCase(actionCreators.iconferenceArticleListClear, state => {
      state[ICONFERENCE_ARTICLE_LIST] = defaultState()
    })

    builder.addCase(actionCreators.iconferenceArticleAllClear, state => {
      state[ICONFERENCE_ARTICLE_ALL] = defaultState()
    })

    builder.addCase(actionCreators.iconferenceMagazineArticleClear, state => {
      state[ICONFERENCE_MAGAZINE_ARTICLE] = defaultState()
    })

    builder.addCase(actionCreators.iconferenceAllClear, state => {
      state[ICONFERENCE_ALL] = defaultState()
    })

    builder.addCase(actionCreators.iconferenceAllFilterClear, state => {
      state[ICONFERENCE_ALL_FILTER] = defaultState()
    })

    builder.addCase(actionCreators.iconferenceCategoryAllClear, state => {
      state[ICONFERENCE_CATEGORY_ALL] = defaultState()
    })
  },
})
